// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide_menu-enter[data-v-4317e372],.slide_menu-leave-to[data-v-4317e372]{opacity:0}.slide_menu-enter-active[data-v-4317e372],.slide_menu-leave-active[data-v-4317e372]{transition:all .5s}", ""]);
// Exports
module.exports = exports;
